var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2124 10.9922L19.2983 1.88581C20.3873 0.794333 22.1114 0.794333 23.2004 1.88581C24.2389 2.92658 24.2694 4.64577 23.2687 5.72575C23.2464 5.74985 23.2236 5.77353 23.2004 5.79676L14.4026 14.6145L10.2124 15.4673V10.9922Z",
    stroke: "#D42E29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7809 0.0289207C17.6856 0.00995137 17.5871 2.67348e-06 17.4863 2.65997e-06L1.5 5.17216e-07C0.671574 4.06176e-07 -9.57322e-09 0.671573 -2.13824e-08 1.5L-2.97931e-07 20.9002C-3.0974e-07 21.7286 0.671573 22.4002 1.5 22.4002L17.4863 22.4002C18.3147 22.4002 18.9863 21.7286 18.9863 20.9002L18.9863 14.3029L17.9863 15.1788L17.9863 20.9002C17.9863 21.1764 17.7624 21.4002 17.4863 21.4002L1.5 21.4002C1.22386 21.4002 1 21.1763 1 20.9002L1 1.5C1 1.22386 1.22386 1 1.5 1L16.8108 1L17.7809 0.0289207Z",
    fill: "#D42E29"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditActiveIcon);
export default __webpack_public_path__ + "static/media/editActiveIcon.f6491ada7b4f50818de2d4bf4d537343.svg";
export { ForwardRef as ReactComponent };